import { Component, Input } from '@angular/core';
import { Patient } from '../../../models/patient';
import { ALaDateDuPipe } from '../../../pipes/a-la-date-du.pipe';
import { TraitementDataComponent } from '../traitement-data/traitement-data.component';

@Component({
  selector: 'app-traitement-data-duree-min-max',
  standalone: true,
  imports: [TraitementDataComponent, ALaDateDuPipe],
  templateUrl: './traitement-data-duree-min-max.component.html',
  styleUrl: './traitement-data-duree-min-max.component.scss'
})
export class TraitementDataDureeMinMaxComponent {
  @Input() patient: Patient | undefined;
}
